
import { BIcon, BIconChatTextFill } from 'bootstrap-vue'
import moment from 'moment'

export default {
  components: {
    BIcon,
    BIconChatTextFill,
  },
  props: {
    slug:{
      type: String,
      default: '',
    },
    img: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    slug: {
      type: String,
      default: '',
    },
    category: {
      type: String,
      default: '',
    },
    readTime: {
      type: String,
      default: '',
    },
    date: {
      type: String,
      default: moment(Date()).format('DD MMM YYYY'),
    },
    writer: {
      type: String,
      default: '',
    },
    synopsis: {
      type: String,
      default: '',
    },
    commentsCount: {
      type: Number,
      default: 0,
    }
  },
  methods: {
    renderTime (val) {
      return moment(val).format('DD MMM YYYY');
    },
    renderWriter (val) {
      const splitWord = val && val.split(' ');
      let splittedVal = '';
      if(splitWord.length > 1) {
        splittedVal = splitWord.slice(0,2).join(' ');
      } else {
        splittedVal = val;
      }
      return splittedVal;
    }
  }
}
